<template>
  <div>
    <Input
      label="account.addressName"
      v-model="form.name"
      :defaultValue="selectedItem.name"
      :state="validateState('name')"
    />

    <Input
      label="account.addressLine1"
      v-model="form.line1"
      :defaultValue="selectedItem.line1"
      :state="validateState('line1')"
    />

    <Input
      label="account.addressLine2"
      v-model="form.line2"
      :defaultValue="selectedItem.line2"
    />

    <Input
      label="global.city"
      v-model="form.city"
      :defaultValue="selectedItem.city"
      :state="validateState('city')"
    />

    <Input
      label="account.state"
      v-model="form.state"
      :defaultValue="selectedItem.state"
    />

    <Input
      label="account.postCode"
      v-model="form.postcode"
      :defaultValue="selectedItem.postcode"
    />

    <b-form-group
      id="countryGroup"
      :label="$t('global.country')"
      label-for="country"
      :state="validateState('country_code')"
    >
      <multiselect
        id="country"
        v-model="form.country_code"
        :options="countries"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('global.country')"
        :custom-label="customCountryLabel"
      >
      </multiselect>
    </b-form-group>

    <Input
      label="global.email"
      v-model="form.email_address"
      :defaultValue="selectedItem.email_address"
      :state="validateState('email_address')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'AddressForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country_code: '',
        email_address: '',
      },
      countries: [],
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      line1: {
        required,
      },
      city: {
        required,
      },
      email_address: {
        email,
      },
      country_code: {
        required,
      },
    },
  },
  created() {
    this.getCountries()
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async getCountries() {
      let res = await ApiService.get('countries')
      this.countries = res.data.data
    },
    customCountryLabel({ name }) {
      return name
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        line1: this.form.line1,
        line2: this.form.line2,
        city: this.form.city,
        state: this.form.state,
        postcode: this.form.postcode,
        country_code: this.form.country_code.code,
        email_address: this.form.email_address,
      }
      if (this.selectedItem == '') this.insertOperation(params)
      else this.updateOperation(params)
    },
    insertOperation(params) {
      //`users/${this.currentUser.user.id}/addresses
      ApiService.post(`accounts/addresses`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.formReset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    updateOperation(params) {
      //`users/${this.currentUser.user.id}/addresses
      ApiService.put(`accounts/addresses/${this.selectedItem.dn}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.formReset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    formReset() {
      this.$v.$reset()
      this.form.name = ''
      this.form.line1 = ''
      this.form.line2 = ''
      this.form.city = ''
      this.form.state = ''
      this.form.postcode = ''
      this.form.email_address = ''
      this.form.country_code = ''
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    selectedItem(newVal) {
      this.formReset()
    },
  },
}
</script>
